import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { ReactComponent as SortIcon } from '../../images/icons/order.svg'
import useSort from '../../hooks/useSort'
import CustomTooltip from '../common/Tooltip';
import styles from './index.module.css'

const SortImages = ({ handleImage, images, orderId, productType }) => {

  const [showOrder, setShowOrder] = useState(false)
  const { sortAscendingByName, sortDescendingByName, sortNewestToOldest, sortOldestToNewest } =
    useSort()
  const [order, setOrder] = useState('')

  const handleSortAscending = () => {
    const newImages = [...images]
    const newPhotos = sortAscendingByName(newImages)
    setOrder('asc')
    handleImage(newPhotos)
    setShowOrder(false)
  }

  const handleSortDescending = () => {
    const newImages = [...images]
    const newPhotos = sortDescendingByName(newImages)
    setOrder('desc')
    handleImage(newPhotos)
    setShowOrder(false)
  }

  const handleSortNewestOldest = () => {
    const newImages = [...images]
    const newPhotos = sortNewestToOldest(newImages)
    setOrder('nto')
    handleImage(newPhotos)
    setShowOrder(false)
  }

  const handleSortOldestNewest = () => {
    const newImages = [...images]
    const newPhotos = sortOldestToNewest(newImages)
    setOrder('otn')
    handleImage(newPhotos)
    setShowOrder(false)
  }

  return (
    <div data-hover="" data-delay="0" className={`${styles.dropdown}`}>
      <CustomTooltip title="Upload More Photos">
        <Link
          to={`/print-order/upload-more/${orderId || ''}?productType=${encodeURIComponent(productType || 'default')}`}
          className={`div-block-169-copy ghost ${styles.uploadMoreButton}`}
          aria-label="Upload more images"
        >
          <div className="icon small w-embed">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#000" viewBox="0 0 256 256">
              <rect width="256" height="256" fill="none" />
              <path d="M128,23.99805a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128,23.99805Zm40,112H136v32a8,8,0,1,1-16,0v-32H88a8,8,0,0,1,0-16h32v-32a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" />
            </svg>
          </div>
        </Link>
      </CustomTooltip>
      {showOrder && (
        <nav className={styles['dropdown-list']}>
          <div className="form-block-filter w-form">
            <form id="email-form-3" name="email-form-3" data-name="Email Form 3" className="form-3">
              <label className="radio-button-field w-radio">
                <div
                  className={`w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input ${
                    order === 'asc' && 'w--redirected-checked'
                  }`}
                />
                <input
                  type="radio"
                  data-name="Radio"
                  id="radio"
                  name="radio"
                  value="Radio1"
                  onClick={handleSortAscending}
                />
                <span className="w-form-label">Ascending (A-Z)</span>
              </label>
              <label className="radio-button-field w-radio">
                <div
                  className={`w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input ${
                    order === 'desc' && 'w--redirected-checked'
                  }`}
                />
                <input
                  type="radio"
                  data-name="Radio 2"
                  id="radio-2"
                  name="radio"
                  value="Radio2"
                  onClick={handleSortDescending}
                />
                <span className="w-form-label">Descending (Z-A)</span>
              </label>
            </form>
            <div className="w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div className="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </nav>
      )}
    </div>
  )
}

export default SortImages
